import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import styled, { ThemeProvider } from "styled-components";
import VisibilityHandler from "./components/Handlers/VisibilityHandler/VisibilityHandler";
import { ExternalContextProvider } from "./context/ExternalContext";
import { FullPageLoadingContextProvider } from "./context/FullPageLoadingContext";
import { InfoContextProvider } from "./context/InfoContext";
import { Router } from "./routes/Router";
import GlobalStyle from "./styles/global";
import getTheme from "./styles/themes/getTheme";
import { muiTheme } from "./styles/themes/muiTheme";
import "./fonts/fonts.css";
import useQuery from "./utils/useQuery";

const Wrapper = styled.div.attrs({ className: "tele-viewbox" })`
  height: 100%;
  container-name: tele-viewbox;
  container-type: inline-size;
`;

const BackgroundContainer = styled("div")`
  height: 100%;
  background-color: ${(props) =>
    props.theme.colors.background || "transparent"};
  background-image: url(${(props) => props.theme.images.background});
  background-position: left center;
  background-repeat: no-repeat;
  background-size: cover;
`;

const App = () => {
  const urlSearchParams = useQuery();

  return (
    <MuiThemeProvider theme={muiTheme}>
      <ThemeProvider theme={getTheme(urlSearchParams.get("theme") || "")}>
        <Wrapper>
          <BackgroundContainer>
            <FullPageLoadingContextProvider>
              <ExternalContextProvider>
                <InfoContextProvider>
                  <GlobalStyle />
                  <Router />
                  <VisibilityHandler />
                </InfoContextProvider>
              </ExternalContextProvider>
            </FullPageLoadingContextProvider>
          </BackgroundContainer>
        </Wrapper>
      </ThemeProvider>
    </MuiThemeProvider>
  );
};

export default App;
